import http from './httpService';
import config from './../config.json';

export const getAllProducts = (params, {cancelToken}) => {
	return http.get(config.api_product, {cancelToken, params});
}

export const getProductsArchive = (params, {cancelToken}) => {
	return http.get(`${config.api_product}/archive`, {cancelToken, params});
}

export const blockingProduct = (_id) => {
    return http.get(`${config.api_product}/blocking/${_id}`);
}

export const createProduct = (product) => {
	return http.post(`${config.api_product}`, product);
}

export const updateProduct = (_id, product) => {
	return http.patch(`${config.api_product}/${_id}`, product);
}

export const deleteProductById = (_id) => {
	return http.delete(`${config.api_product}/${_id}`);
}

export const checkShoppingCartItems = (params, {cancelToken}) => {
	return http.get(`${config.api_product}/check-shopping-cart`, {params, cancelToken});
}